export default "__VITE_ASSET__BBl484yB__"